import { AlertBox } from '@life-line-lab/components-react';
import { DragNDropUpload } from 'Components/base';
import { last } from 'lodash';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FileType } from 'src/models/common';
import './upload-e-prescription-container.scss';

interface UploadEPrescriptionContainerProps {
  isError: boolean;
  title: string;
  fileList: FileType[];
  handleFilesChange: (files: FileType[]) => void;
  handleRemoteFilesToRemove: (fileID: string) => void;
  footer?: ReactNode;
}

const SUPPORTED_FORMATS = '.png, .jpg, .jpeg, .pdf';
const SUPPORTED_FORMATS_LIST = ['image/png', 'image/jpeg', 'application/pdf'];

const UploadEPrescriptionContainer = ({
  isError,
  title,
  fileList,
  handleFilesChange,
  handleRemoteFilesToRemove,
  footer,
}: UploadEPrescriptionContainerProps) => {
  const { t } = useTranslation();

  const handleChange = async ({ fileList: updatedFileList }: { fileList: FileType[] }) => {
    const lastFile = last(updatedFileList);
    if (!lastFile) {
      handleFilesChange([]);
    }
    if (!lastFile?.fileID && !SUPPORTED_FORMATS_LIST.includes(lastFile?.type)) {
      return;
    }

    handleFilesChange(updatedFileList);
  };

  const handleRemove = (file: FileType) => {
    if (file.fileID) {
      handleRemoteFilesToRemove(file.fileID);
    }
  };

  return (
    <div className="p-20 m-20 page--container upload-e-prescription-container">
      <div className="upload-e-prescription-container__inner">
        <h3 className="mb-20">{title}</h3>

        <DragNDropUpload
          onChange={handleChange}
          onRemove={handleRemove}
          fileList={fileList}
          fileFormat={SUPPORTED_FORMATS}
          multiple
          uploadText={
            <div className="p-10">
              <p
                className="heading"
                dangerouslySetInnerHTML={{ __html: t('label.dragAndDropFilesOrBrowse') }}
              />
              <p className="sub-heading">
                {t('label.supportedFormats.formatData', { formatData: 'PNG, JPEG, PDF' })}
              </p>
            </div>
          }
        />

        {
          isError &&
          <AlertBox text={t('error.required', { field: t('label.ePrescription')})} />
        }

        {footer}
      </div>
    </div>
  );
};

export default UploadEPrescriptionContainer;
